<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <!-- Jobs -->
    <div id="print" class="card-panel-main col-lg-9 mb-5  " style="transform: translateX(-19vw)">
      <div class="d-flex flex-nowrap no_print hide">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between ">
              <h2 style="font-size: 1.2vw !important;">دسته‌ بندی فرآیند</h2>
            </div>
            <form class="needs-validation" novalidate >
              <div class="row">
                <div class="col-lg-2 mb-3 ms-n-08" style="width: 9vw;">
                  <label class="form-label required">عنوان دسته</label>
                  <textarea class="form-control" v-model="nameCat" :style="{ height: nameCatHeight }" cols="30" rows="1"></textarea>
                </div>
                <div class="col-lg-2 mb-3 ms-n-08" style="width: 9vw;">
                  <label class="form-label ">عنوان انگلیسی</label>
                  <textarea class="form-control" v-model="title_en" :style="{ height: title_enHeight }" cols="30" rows="1"></textarea>
                </div>
                <div style="width: 9vw;" class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label required">نحوه کدگذاری </label>
                  <select class="form-select" v-model="encodingMethodCat" required>
                    <option value="" disabled selected>انتخاب کنید</option>
                    <option value="حرف اختصاری">حرف اختصاری</option>
                    <option value="عدد">عدد</option>
                    <option value="حرف اختصاری و عدد">حرف اختصاری و عدد</option>
                  </select>
                </div>
                <div style="width: 8vw;" class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label required">حرف اختصاری</label>
                  <input :disabled="encodingMethodCat==='عدد'" :placeholder="encodingMethodCat==='عدد' ? 'ندارد' : ''"
                         class="form-control" v-model="shortNameCat">
                </div>


                <div style="width: 10vw;" class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label required"> سطوح زیرمجموعه</label>
                      <input readonly @click="addNewSelectedSub"

                         :placeholder="subLevelsCat1 ||
subLevelsCat2||
subLevelsCat3||
subLevelsCat4 ? ((subLevelsCat1 ? 'طبقه' : '')+' '+(subLevelsCat2? 'گروه' : '')+' '+(subLevelsCat3? 'فرآیند' : '')+' '+(subLevelsCat4? 'زیرفرآیند' : '')):'انتخاب کنید'"
                         type="text" class="form-control" placeholder="انتخاب کنید">

                </div>
                <div class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label required">سطح تعریف شناسنامه </label>
                  <input readonly @click="addNewIdCard" type="text" class="form-control"
                  :placeholder="subLevelsCat2_id||subLevelsCat3_id||subLevelsCat4_id ? ((subLevelsCat2_id ? 'گروه' :'')+' '+(subLevelsCat3_id ? 'فرآیند':'')+' '+(subLevelsCat4_id ? 'زیر فرآیند' : '')):''"
                  >


                </div>
                <div class="col-lg-2 mb-3 ms-n-08" style="margin-top: 1.5vw;">
                  <input class="form-check-input " type="checkbox" v-model="isValueChainCat">
                  <label style="margin-right: .5vw; margin-top: -.2vw; font-size: 1vw;" class="form-check-label ">زنجیره
                    ارزش است</label>
                </div>
                <button style="transform: translateY(1.5vw)"  class="btn btn-primary btn-submit-1" type="button" @click="addCategory">
                  <p v-if="!loader"
                     style="font-size: 1.8vw; transform: translateY(.80vw)">+</p>
                  <div v-else>
                    <div class="loader-line"></div>

                  </div>
                </button>
              </div>


            </form>
            <hr >


          </div>
        </div>
      </div>
      <div v-show="allProcesses.length" class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <h2 style="font-size: 1.2vw !important;width: 18vw;">لیست فرآیند ها و نقشه فرآیندی</h2>
            </div>
            <form class="needs-validation mt-2 mb-3" novalidate>
              <div class="row">

                <div style="transform: translateY(-1.5vw)" class="hide col-lg-12 mb-3 no_print">
                  <input v-model="searchProcesses" type="text" class="form-control" style="width: 20vw;"
                         placeholder="جستجو بر اساس عنوان و کد  ...">
                </div>
              </div>
              <hr style="transform: translateY(-1.9vw)">

            </form>
            <div style="transform: translateY(-1.5vw)" class="table-responsive">
              <table v-show="allProcesses.length" class="table table-striped">
                <thead>
                <tr>
                  <th>ردیف</th>
                  <th>کد</th>
                  <th>عنوان</th>
                  <th>معادل انگلیسی عنوان</th>
                  <th>سطح فرآیند</th>
                  <th>مالک فرآیند</th>
                  <th  class="no_print hide" style="width: 14vw;">عملیات‌ها</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in filteredItems" :style="setcolor(item['level'])">
                  <td scope="row">{{ index + 1 }}</td>
                  <td>{{ item['code'] }}</td>
                  <td style="text-align: right">{{ item['title'] }}</td>

                  <td v-if="item['title_en']"> {{ item['title_en'] }}</td>
                  <td v-else>
                    --
                  </td>
                  <td v-if="item['type']">
                    <span v-if="item['type']==1">
                      طبقه
                    </span>
                    <span v-else-if="item['type']==2">گروه</span>
                    <span v-else-if="item['type']==3">فرآیند</span>
                    <span v-else-if="item['type']==4">زیرفرآیند</span>
                  </td>
                   <td v-else>
                    دسته
                  </td>
                  <td>
                    <VSelect
                        v-model="item.organization_post"
                        :options="organizationPosts"
                        label="name"
                        placeholder="مالک را انتخاب کنید"
                        dir="rtl"
                        @update:modelValue="handleUpdateOrganizationPost(item)">
                      <template v-slot:no-options>
                        مالک یافت نشد!
                      </template>
                    </VSelect>
                  </td>
                  <td class="no_print hide">
                    <div class="d-flex  ">
                      <div class="d-flex  " style="width: 13.5vw;">
                        <a
                            @click.prevent="previousTree(item['id'])"
                            href="#"><img  class="table-edit-img"
                                          src="../../assets/img/prev.svg"
                                          alt="prev"></a>
                        <a
                            style="margin-right:  0.5vw;"

                            @click.prevent="nextTree(item['id'])"

                            href="#"><img   class="table-edit-img"
                                          src="../../assets/img/next.svg"
                                          alt="next"></a>
                        <a
                            style="margin-right:  0.5vw;"

                            @click.prevent="editMethod(item['id'])" href="#"><img
                                                                                 class="table-edit-img"
                                                                                 src="../../assets/img/pen.svg"
                                                                                 alt="edit"></a>
                        <a
                            style="margin-right:  0.5vw;"

                            @click.prevent="deleteItemModal(item['id'])" href="#"><img
                                                                                      class="table-delete-img"
                                                                                      src="../../assets/img/delete.svg"
                                                                                      alt="delete"></a>
                        <Bpm @click.prevent="addModelDesign(item.id)" title="مدلسازی" style="width: 1.5vw;"/>
                        <a
                            v-if="resultShow(parseInt(item.type),item.is_floor,item.is_group,item.is_process,item.is_sub_process)"
                            href="#"
                            @click.prevent="parseInt(item['type'])!==4 ? addParentProcessesMethod(item['id'], item['type']) : ''"
                            style="display:inline-block; transform: translateY(.1vw); width: 1.5vw; height: 1.5vw; text-decoration: none; font-size: 1.1vw; background-color: green; border-radius: 50%;  color: white;text-align: center;">+</a>
                        <p v-else>
                          <span style="width: 1.9vw; display:block;"></span>
                        </p>
                      </div>
                      <router-link  v-show="showIdCard(item['idcard_group'] , item['idcard_process'],item['idcard_sub_process'],item['type'])"
                                      :to="`/process/id/complete/${item['id']}`"><img  class="table-edit-img" src="/img/id.02f9043a.svg"
                                                                                      alt="prev">  </router-link>


                    </div>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-show="allProcesses.length">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-between align-items-center mb-3">
              <h2 class="font_print" style="font-size: 1.2vw !important;width: 9vw;     transform: translateY(0.5vw);">
                نقشه فرآیندی</h2>
              <img @click="showMore=!showMore"
                   style="transition: transform ease 500ms; width: 2.4vw; height: 2.4vw; transform: rotate(-90deg); cursor: pointer;"
                   :style="showMore ? 'transform: rotate(90deg);' : ''" class="me-2 no_print hide"
                   src="/img/left-arrow.8e96c359.svg" alt="left-arrow">
            </div>
            <div v-show="showMore">
              <div class="d-flex flex-wrap" style="transition: all ease 500ms;">

                <div v-for="item in table_all_Processes"
                     :key="item"
                     class="card card-body card-panel-box card-process-map-1 border-0 "
                     :style="{
       width: table_all_Processes_floor.filter(ele => ele.parent_id === item.id).length !== 1 ? '62vw !important' : ''
     }"
                >
                  <h3 style="font-size: 0.9vw !important;font-weight: 400; width: 9vw;margin-bottom: 0vw;margin-right: 1vw;color: #FFF;">
                    {{ item.title }}
                    <br>
                    کد: {{ item.code }}
                  </h3>
                  <div class="d-flex flex-wrap">
                    <div v-for="(i,index) in item.floors"
                         class="card card-body card-panel-box card-process-map-2 mb-3 border-0 w-auto"
                         :style="{
       width: table_all_Processes_groups.filter(ele => ele.parent_id === i.id).length !== 1 ? '26vw !important' : ''
     }"

                    >
                      <h3 style="font-size: 0.9vw !important;font-weight: 400; width: 9vw;margin-bottom: 0vw;margin-right: 1vw;color: #000;">
                        {{ i.title }}</h3>
                      <div class="row">
                        <div v-for="j in i.groups" class="col-lg-6">
                          <div class="card card-body card-panel-box card-process-map-3 border-0">
                            <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 1vw;color: #000;">
                              {{ j.title }}</h3>
                            <div v-for="k in j.processes"
                                 class="card card-body card-panel-box card-process-map-4 mb-3 border-0">
                              <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.8vw;color: #000;">
                                {{ k.title }}</h3>
                              <div class="row">
                                <div v-for="l in k.subProcesses"
                                     class="col-lg-4">
                                  <div class="card card-body card-panel-box card-process-map-5 border-0"  style="width: 5vw;height: auto;display: flex;flex-direction: row;align-content: center;justify-content: center;align-items: center;">
                                    <h3 style="font-size: 0.6vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.3vw;color: #000;">
                                      {{ l.title }} </h3>
                                    <br>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <!--            item-->
                <div v-for="item in table_all_Processes_by_group"
                     class="card card-body card-panel-box card-process-map-1 border-0">
                  <h3 style="font-size: 0.9vw !important;font-weight: 400; width: 9vw;margin-bottom: 0vw;margin-right: 1vw;color: #FFF;">
                    {{ item.title }}
                    <br>
                    کد: {{ item.code }}
                  </h3>

                  <div class="row">
                    <div v-for="j in item.groups"
                         class="col-lg-6">
                      <div class="card card-body card-panel-box card-process-map-3 border-0">
                        <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 1vw;color: #000;">
                          {{ j.title }}</h3>
                        <div v-for="k in j.processes"
                             class="card card-body card-panel-box card-process-map-4 mb-3 border-0">
                          <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.8vw;color: #000;">
                            {{ k.title }}</h3>
                          <div class="row">
                            <div v-for="l in k.subProcesses"
                                 class="col-lg-4">
                              <div class="card card-body card-panel-box card-process-map-5 border-0">
                                <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.3vw;color: #000;">
                                  {{ l.title }} </h3>
                                <br>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <!--            item-->

                <!--            item-->
                <div v-for="item in table_all_Processes_by_processes"
                     class="card card-body card-panel-box card-process-map-1 border-0">
                  <h3 style="font-size: 0.9vw !important;font-weight: 400; width: 9vw;margin-bottom: 0vw;margin-right: 1vw;color: #FFF;">
                    {{ item.title }}
                    <br>
                    کد: {{ item.code }}
                  </h3>

                  <div class="row">

                    <div v-for="k in item.processes"
                         class="card card-body card-panel-box card-process-map-4 mb-3 border-0">
                      <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.8vw;color: #000;">
                        {{ k.title }}</h3>
                      <div class="row">
                        <div v-for="l in k.subProcesses"
                             class="col-lg-4">
                          <div class="card card-body card-panel-box card-process-map-5 border-0">
                            <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.3vw;color: #000;">
                              {{ l.title }} </h3>
                            <br>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
                <!--            item-->
                <!--            item-->
                <div v-for="item in table_all_Processes_by_sub_process"
                     class="card card-body card-panel-box card-process-map-1 border-0">
                  <h3 style="font-size: 0.9vw !important;font-weight: 400; width: 9vw;margin-bottom: 0vw;margin-right: 1vw;color: #FFF;">
                    {{ item.title }}
                    <br>
                    کد: {{ item.code }}
                  </h3>

                  <div class="row">


                    <div class="row">
                      <div v-for="l in item.subProcesses" v-show="l.parent_id===item.id"
                           class="col-lg-4">
                        <div class="card card-body card-panel-box card-process-map-5 border-0">
                          <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.3vw;color: #000;">
                            {{ l.title }} </h3>
                          <br>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
                <!--            item-->

              </div>
            </div>
            <hr>
            <center class="mt-5 d-print-none no_print">
              <router-link to="/process/map/print" class="hide btn btn btn-primary btn-submit-1">پرینت</router-link>
            </center>

          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="openModalsubLevelsCat" style="z-index: 999999999999999">
    <div>
      <p>انتخاب سطوح زیرمجموعه</p>
      <p @click="openModalsubLevelsCat=!openModalsubLevelsCat">❌</p>
    </div>
    <div>
      <div style="background-color: #fff; width: 25vw; padding: 1vw; border-radius: 1vw">
        <p class="text-end">
          <label style="font-size: 1vw">
            <input v-model="subLevelsCat1" type="checkbox" value="طبقه">
            طبقه
          </label>
        </p>
        <p class="text-end" style="transform: translateX(2vw)">
          <label style="font-size: 1vw; margin-right: 2vw;">
            <input v-model="subLevelsCat2" type="checkbox" value="گروه">
            گروه
          </label>
        </p>
        <p class="text-end">
          <label style="font-size: 1vw">
            <input v-model="subLevelsCat3" type="checkbox" value="فرآیند">
            فرآیند
          </label>
        </p>
        <p class="text-end" style="transform: translateX(2vw)">
          <label style="font-size: 1vw; margin-right: 2vw;">
            <input v-model="subLevelsCat4" type="checkbox" value="زیر فرآیند">
            زیر فرآیند
          </label>
        </p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="openModalsubLevelsCat=!openModalsubLevelsCat" class="btn btn-primary btn-back" type="submit">
          برگشت
        </button>
        <button class="btn btn-primary btn-approve" @click="removeModalSelectedSub">تایید</button>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="openModalsubLevelsCatForIdCard"
       style="z-index: 999999999999999">
    <div>
      <p>سطح تعریف شناسنامه</p>
      <p @click="openModalsubLevelsCatForIdCard=!openModalsubLevelsCatForIdCard">❌</p>
    </div>
    <div>
      <div style="background-color: #fff; width: 25vw; padding: 1vw; border-radius: 1vw">

        <p v-show="subLevelsCat2" class="text-end" style="transform: translateX(2vw)">
          <label style="font-size: 1vw; margin-right: 2vw;">
            <input v-model="subLevelsCat2_id" type="checkbox" value="گروه">
            گروه
          </label>
        </p>
        <p v-show="subLevelsCat3" class="text-end">
          <label style="font-size: 1vw">
            <input v-model="subLevelsCat3_id" type="checkbox" value="فرآیند">
            فرآیند
          </label>
        </p>
        <p v-show="subLevelsCat4" class="text-end" style="transform: translateX(2vw)">
          <label style="font-size: 1vw; margin-right: 2vw;">
            <input v-model="subLevelsCat4_id" type="checkbox" value="زیر فرآیند">
            زیر فرآیند
          </label>
        </p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="openModalsubLevelsCatForIdCard=!openModalsubLevelsCatForIdCard" class="btn btn-primary btn-back"
                type="submit">
          برگشت
        </button>
        <button class="btn btn-primary btn-approve"
                @click="openModalsubLevelsCatForIdCard=!openModalsubLevelsCatForIdCard">تایید
        </button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->

  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="modalTitleFa" style="z-index: 999999999999999">
    <div>
      <p>ویرایش عنوان</p>
      <p @click="modalTitleFa=!modalTitleFa">❌</p>
    </div>
    <div>
      <div>
        <input v-model="title_for_edit_fa" placeholder="عنوان خود را وارد کنید" type="text" class="form-control"
               style="width: 20vw;">
      </div>
      <button @click="updateTitles(this.ProcessesId)">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="modalTitleEn" style="z-index: 999999999999999">
    <div>
      <p>ویرایش عنوان انگلیسی</p>
      <p @click="modalTitleEn=!modalTitleEn">❌</p>
    </div>
    <div>
      <div>
        <input v-model="title_for_edit_en" placeholder="عنوان انگلیسی خود را وارد کنید" type="text" class="form-control"
               style="width: 20vw;">
      </div>
      <button @click="updateTitles(ProcessesId)">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->

  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(ProcessesId)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="addParentProcesses" style="z-index: 999999999999999">
    <div>
      <p>افزودن زیرمجموعه {{ itemProcesses.category }}</p>
      <p @click="addParentProcesses=!addParentProcesses">❌</p>
    </div>
    <div v-if="(((itemProcesses.is_floor && is_floor_select) || (itemProcesses.is_group && is_group_select) || (itemProcesses.is_process && is_process_select) || (itemProcesses.is_sub_process && is_sub_process_select)) === false)">
      <center class="bg-white p-3" style="border-radius: 1vw">
        سطح پایین تری در فرآیند {{ itemProcesses.category }} وجود ندارد!
      </center>
    </div>
    <div v-else>
      <div>
        <div class="d-flex">
          <div>
            <label class="required" style="font-size: .88vw; text-align: right;width: 100%;">عنوان</label>
            <input v-model="title_for_edit_fa_processes" placeholder="عنوان خود را وارد کنید" style="width: 13vw;" type="text" class="form-control">
          </div>
          <div style="font-size: .88vw; text-align: right">
            <label class="">عنوان انگلیسی</label>
            <input v-model="title_for_edit_en_processes" placeholder="عنوان انگلیسی را وارد کنید" style="width: 13vw; margin-right: 1vw;" type="text" class="form-control">
          </div>
        </div>
        <br>
        <label class="required" style="font-size: .88vw; text-align: right;width: 100%;">سطح فرآیند </label>
        <select v-model="levelSub_processes" class="form-select">
          <option v-if="itemProcesses.is_floor && is_floor_select" value="1">طبقه</option>
          <option v-if="itemProcesses.is_group && is_group_select" value="2">گروه</option>
          <option v-if="itemProcesses.is_process && is_process_select" value="3">فرآیند</option>
          <option v-if="itemProcesses.is_sub_process && is_sub_process_select" value="4">زیر فرآیند</option>
        </select>
      </div>
      <button @click="SubmitParent">تایید</button>
    </div>
  </div>


  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="editModal" style="z-index: 999999999999999">
    <div>
      <p>ویرایش</p>
      <p @click="editModal=!editModal">❌</p>
    </div>
    <div>
      <div>
        <div class="d-flex">
          <div>
            <label style="font-size: .88vw; text-align: right;width: 100%;">عنوان</label>
            <input v-model="title_for_edit_fa" placeholder="عنوان خود را وارد کنید" style="width: 13vw;" type="text"
                   class="form-control">
          </div>
          <div style="font-size: .88vw; text-align: right">
            <label>عنوان انگلیسی</label>
            <input v-model="title_for_edit_en" placeholder="عنوان انگلیسی را وارد کنید"
                   style="width: 13vw; margin-right: 1vw;" type="text" class="form-control">
          </div>
        </div>

        <br>

        <label v-if="levelSub" style="font-size: .88vw; text-align: right;width: 100%;">سطح فرآیند </label>
        <select v-if="levelSub" v-model="levelSub" class="form-select">
          <option value="" selected disabled>انتخاب کنید</option>
          <option v-if="itemProcesses.is_floor" value="1">طبقه</option>
          <option v-if="itemProcesses.is_group" value="2">گروه</option>
          <option v-if="itemProcesses.is_process" value="3">فرآیند</option>
          <option v-if="itemProcesses.is_sub_process" value="4">زیر فرآیند</option>
        </select>
      </div>
      <button @click="updateForm(ProcessesId)">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="Error" style="z-index: 999999999999999">
    <div>
      <p>خطا</p>
      <p @click="Error=!Error">❌</p>
    </div>
    <div>
      <p>{{ ErrorM }}</p>
      <button @click="Error=!Error">تایید</button>
    </div>
  </div>
  <!-- modal  -->
</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import router from "@/router";
import Bpm from "@/components/Docs/Bpm.vue";
import {useToast} from "vue-toastification";
import useApi from "@/composables/useApi";
import VSelect from "vue-select";

const toast = useToast();
const {fetchResource, updateResource} = useApi()

export default {
  name: "process_map",
  components: {VSelect, Bpm, Sidebar, Splash},
  data() {
    return {
      organizationPosts: [],
      selectedPost: null,
      //*******************************
      //*******************************
      // todo: for categories *******************************
      // *******************************
      categories: [],
      nameCat: '',
      shortNameCat: '',
      encodingMethodCat: '',
      level_cardid: '',
      title_en: '',
      subLevelsCat1: '',
      subLevelsCat2: '',
      subLevelsCat3: '',
      subLevelsCat4: '',
      sub_id: 0,
      is_CRUD: false,
      isValueChainCat: false,
      openModalsubLevelsCat: false,
      // todo: for categories *******************************
      //*******************************
      // *******************************
      Error: false,
      loader: false,
      ErrorM: '',
      // *******************************
      // *******************************
      // todo: for Processes *******************************
      allProcesses: [],
      searchProcesses: '',
      ProcessesId: '',
      addParentProcesses: false,
      modalTitleEn: false,
      modalTitleFa: false,
      editModal: false,
      deleteModal: false,
      showMore: false,
      title_for_edit: '',
      title_for_edit_fa: '',
      levelSub: '',
      title_for_edit_en: '',
      itemProcesses: [],
      table_all_Processes: [],
      table_all_Processes_floor: [],
      table_all_Processes_groups: [],
      table_all_Processes_process: [],
      table_all_Processes_sub_process: [],

      title_for_edit_fa_processes: '',
      title_for_edit_en_processes: '',
      levelSub_processes: '',
      //*******************************
      table_all_Processes_by_group: [],
      table_all_Processes_groups_by_group: [],
      table_all_Processes_process_by_group: [],
      table_all_Processes_sub_process_by_group: [],
      //*******************************
      table_all_Processes_by_processes: [],
      table_all_Processes_process_by_processes: [],
      table_all_Processes_sub_process_by_processes: [],
      //*******************************
      table_all_Processes_by_sub_process: [],
      table_all_Processes_sub_process_by_sub_process: [],

      is_floor_select: false,
      is_group_select: false,
      is_process_select: false,
      is_sub_process_select: false,


      // todo: for Processes *******************************
      //*******************************
      //*******************************
      openModalsubLevelsCatForIdCard: false,
      subLevelsCat2_id: '',
      subLevelsCat3_id: '',
      subLevelsCat4_id: '',
      id_user: '',
      //*******************************
      //*******************************

    };
  },
  methods: {
    addModelDesign(id){

      window.location.href=`${this.download_url}/DesignAndModeling/${this.id_user}?token=${this.$cookies.get('id_login')}&process_id=${id}`
    },
    resultShow(type,is_floor,is_group,is_process,is_sub_process){
      if (!type){
        type=0
      }
      if (type===4){
        return  false
      }else if(type===0){
        return  true
      }
      else if (type===1){
        if (is_group){
          return true
        }
        return false
      } else if (type===2){
        if (is_process){
          return true
        }
        return false
      } else if (type===3){
        if (is_sub_process){
          return true
        }
        return false
      }
    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.logout()
              return;
            }
            if (result['item']) {
              if (this.is_mother){
                this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
    stylechange(id) {
      this.table_all_Processes_floor.forEach((ele) => {


        if (id === ele.parent_id) {
          return 'width: 32vw !important;';
        }


      })
    },
    showIdCard(is_group, is_pro, is_subPro, type) {
      let typeNumber = parseInt(type)
      if (is_group && typeNumber === 2) {
        return true

      } else if (is_pro && typeNumber === 3) {
        return true

      } else if (is_subPro && typeNumber === 4) {
        return true

      }
      return false
    },
    addNewIdCard() {

      this.openModalsubLevelsCatForIdCard = true

    }, addNewSelectedSub() {

      this.openModalsubLevelsCat = true

    },
    printMethod() {


    },
    editMethod(id) {
      this.edit(id)
      this.ProcessesId = id
      this.editModal = true
    },
    nextTree(id) {


      fetch(`${this.base_url}/processes/change_tree/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error) {
              this.Error = true
              this.ErrorM = response.error
              return
            }
            this.fetchAllProcesses()
          }).catch((err) => {
        console.log(err)
      })


    },
    previousTree(id) {


      fetch(`${this.base_url}/processes/change_tree/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: {
          'type': 'previous'
        }
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error) {
              this.Error = true
              this.ErrorM = response.error
              return
            }
            this.fetchAllProcesses()
          }).catch((err) => {
      })

    },
    setcolor(level) {

      if (level === 0) {
        return 'background: #4eb4ff !important'

      }


      if (level === 1) {
         return 'background: #4eb4ffc7 !important'

      }
      if (level === 2) {
        return 'background: #4eb4ff8a !important'

      }
      
      if (level === 3) {
         return 'background: #4eb4ff52 !important'

      }
       else {
         return 'background: white !important'
      }



    },

    addParentProcessesMethod(id, type) {
      // console.log(type)
      this.ProcessesId = id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.itemProcesses = result.item


            if (result.item.is_floor && this.is_floor_select) {
              this.levelSub_processes = '1';
            } else if (result.item.is_group && this.is_group_select) {
              this.levelSub_processes = '2';
            } else if (result.item.is_process && this.is_process_select) {
              this.levelSub_processes = '3';
            } else if (result.item.is_sub_process && this.is_sub_process_select) {
              this.levelSub_processes = '4';
            } else {
              this.levelSub_processes = '';
            }
            if (result.item.type==='null'){
              this.levelSub_processes = '1';
              this.is_floor_select = true
            }


            this.title_for_edit_fa = result.item.title
            this.title_for_edit_en = result.item.title_en
            this.levelSub = result.item.type


          })
          .catch();
      if (type == null) {
        this.is_floor_select = true
        this.is_group_select = true
        this.is_process_select = true
        this.is_sub_process_select = true

      }
      if (type == 1) {
        this.is_floor_select = false
        this.is_group_select = true
        this.is_process_select = false
        this.is_sub_process_select = false
      }
      if (type == 2) {
        this.is_floor_select = false
        this.is_group_select = false
        this.is_process_select = true
        this.is_sub_process_select = false
      }
      if (type == 3) {
        this.is_floor_select = false
        this.is_group_select = false
        this.is_process_select = false
        this.is_sub_process_select = true
      }
      if (type == 4) {
        this.is_floor_select = false
        this.is_group_select = false
        this.is_process_select = false
        this.is_sub_process_select = false

      }
      this.addParentProcesses = true
      this.itemProcesses.length = 0
      this.title_for_edit_fa = ''
      this.levelSub = ''
      this.title_for_edit_en = ''
      this.ProcessesId = id
      this.title_for_edit_fa_processes = ''
      this.title_for_edit_en_processes = ''
      this.levelSub_processes = ''

    },
    SubmitParent() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title_for_edit_fa_processes);
      formdata.append('title_en', this.title_for_edit_en_processes);
      formdata.append('levelSub', this.levelSub_processes);


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/processes/store_parent/${this.ProcessesId}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.categories.length = 0
            this.fetchAllProcesses()
            this.addParentProcesses = !this.addParentProcesses


          })
          .catch();
    },
    deleteItemModal(id) {
      this.ProcessesId = id
      this.deleteModal = true

    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.allProcesses.length = 0
            this.fetchAllProcesses()
            this.deleteModal = false


          })
          .catch();

    },
    fetchAllProcesses() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            if (result.items.length) {
              this.allProcesses.length = 0
              result.items.forEach((ele) => {
                this.allProcesses.push(ele)


              })
            }


          })
          .catch();

      fetch(`${this.base_url}/processes/all_table`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result.items.length) {
              this.table_all_Processes.length = 0
              this.table_all_Processes_groups.length = 0
              this.table_all_Processes_process.length = 0
              this.table_all_Processes_floor.length = 0
              this.table_all_Processes_sub_process.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes.push(ele)

              })

            }


          })
          .catch();
      fetch(`${this.base_url}/processes/all_table_by_group`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result.items.length) {
              this.table_all_Processes_by_group.length = 0
              this.table_all_Processes_groups_by_group.length = 0
              this.table_all_Processes_process_by_group.length = 0
              this.table_all_Processes_sub_process_by_group.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes_by_group.push(ele)

              })
            }
          })
          .catch();
      fetch(`${this.base_url}/processes/all_table_by_process`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result.items.length) {
              this.table_all_Processes_by_processes.length = 0
              this.table_all_Processes_process_by_processes.length = 0
              this.table_all_Processes_sub_process_by_processes.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes_by_processes.push(ele)

              })
              result.process.forEach((ele) => {
                this.table_all_Processes_process_by_processes.push(ele)

              })
              result.sub_process.forEach((ele) => {
                this.table_all_Processes_sub_process_by_processes.push(ele)

              })

            }


          })
          .catch();
      fetch(`${this.base_url}/processes/all_table_by_sub_process`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result.items.length) {
              this.table_all_Processes_by_sub_process.length = 0
              this.table_all_Processes_sub_process_by_sub_process.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes_by_sub_process.push(ele)

              })

              result.sub_process.forEach((ele) => {
                this.table_all_Processes_sub_process_by_sub_process.push(ele)

              })

            }


          })
          .catch();
    },
    editTitleFa(id) {
      this.title_for_edit_fa = ''

      this.ProcessesId = id
      this.modalTitleFa = true


    },
    updateTitles(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.title_for_edit_fa.length) {
        formdata.append('title', this.title_for_edit_fa)

      }
      if (this.title_for_edit_en.length) {
        formdata.append('title_en', this.title_for_edit_en)

      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.modalTitleFa = false
            this.modalTitleEn = false
            this.title_for_edit_fa = ''
            this.title_for_edit_en = ''
            this.fetchAllProcesses()


          })
          .catch();
    },
    updateForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('title', this.title_for_edit_fa)
      formdata.append('title_en', this.title_for_edit_en)
      formdata.append('type', this.levelSub)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/update_parent/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }

            this.editModal = false
            this.title_for_edit_fa = ''
            this.title_for_edit_en = ''
            this.fetchAllProcesses()


          })
          .catch();
    },
    editTitleEn(id) {
      this.ProcessesId = id
      this.title_for_edit_en = ''
      this.modalTitleEn = true

    },
    edit(id) {
      this.ProcessesId = id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.itemProcesses = result.item

            if (result.item.is_floor && !result.item.type) {
              this.levelSub_processes = 1
            } else if (result.item.is_group && result.item.type == 1) {
              this.levelSub_processes = 2

            } else if (result.item.is_sub_process && result.item.type == 2) {
              this.levelSub_processes = 3

            } else if (result.item.is_process && result.item.type == 3) {
              this.levelSub_processes = 4

            }

            this.title_for_edit_fa = result.item.title
            this.title_for_edit_en = result.item.title_en
            this.levelSub = result.item.type


          })
          .catch();
    },


    //*******************************
    //*******************************
    // todo: for categories *******************************
    SubmitSubCategories() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('categories', JSON.stringify(this.categories));


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/processes/store`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.categories.length = 0
            this.fetchAllProcesses()


          })
          .catch();
    },
    addCategory() {
      if (this.loader){
        return;
      }
      this.loader = true
      if (!this.nameCat.length) {
        this.ErrorM = 'عنوان دسته اجباری است'
        toast.error(this.ErrorM)

        this.loader = false

        return
      }  else if (!this.encodingMethodCat.length) {
        this.ErrorM = 'نحوه کدگذاری طبقه اجباری است'
        toast.error(this.ErrorM)

        this.loader = false
        toast.error(this.ErrorM)

        return
      } else if (!this.subLevelsCat1 && !this.subLevelsCat2 && !this.subLevelsCat3 && !this.subLevelsCat4) {
        this.ErrorM = 'حداقل یک عناوین سطوح زیر مجموعه انتخاب کنید'
        toast.error(this.ErrorM)
        this.loader = false
        return
      }
      this.categories.push({
        name: this.nameCat,
        title_en: this.title_en,
        shortName: this.shortNameCat,
        encodingMethod: this.encodingMethodCat,
        subLevelsCat1: this.subLevelsCat1,
        subLevelsCat2: this.subLevelsCat2,
        subLevelsCat3: this.subLevelsCat3,
        subLevelsCat4: this.subLevelsCat4,
        isValueChain: this.isValueChainCat,
        subLevelsCat2_id: this.subLevelsCat2_id,
        subLevelsCat3_id: this.subLevelsCat3_id,
        subLevelsCat4_id: this.subLevelsCat4_id,
      });
      this.SubmitSubCategories()
      this.nameCat = ''
      this.shortNameCat = ''
      this.encodingMethodCat = ''
      this.subLevelsCat1 = ''
      this.subLevelsCat2 = ''
      this.subLevelsCat3 = ''
      this.subLevelsCat4 = ''
      this.isValueChainCat = ''
      this.subLevelsCat2_id = ''
      this.subLevelsCat3_id = ''
      this.subLevelsCat4_id = ''
      this.title_en = ''
      this.level_cardid = ''
      this.loader = false

    },
    removeCategory(index) {
      this.categories.splice(index, 1);
    },
    showSelectedSubCatMethod(id, subLevelsCat1, subLevelsCat2, subLevelsCat3, subLevelsCat4) {
      this.subLevelsCat1 = subLevelsCat1
      this.subLevelsCat2 = subLevelsCat2
      this.subLevelsCat3 = subLevelsCat3
      this.subLevelsCat4 = subLevelsCat4
      this.openModalsubLevelsCat = true
      this.sub_id = id


    },
    showSelectedSubCatIdCardMethod(subLevelsCat1, subLevelsCat2, subLevelsCat3) {
      this.subLevelsCat2 = subLevelsCat1
      this.subLevelsCat3 = subLevelsCat2
      this.subLevelsCat4 = subLevelsCat3
      this.subLevelsCat2_id = subLevelsCat1
      this.subLevelsCat3_id = subLevelsCat2
      this.subLevelsCat4_id = subLevelsCat3
      this.openModalsubLevelsCatForIdCard = true


    },

    removeModalSelectedSub() {
      this.openModalsubLevelsCat = false

      this.categories.forEach((element, index) => {
        if (index === this.sub_id) {
          element.subLevelsCat1 = this.subLevelsCat1;
          element.subLevelsCat2 = this.subLevelsCat2;
          element.subLevelsCat3 = this.subLevelsCat3;
          element.subLevelsCat4 = this.subLevelsCat4;

        }
      })
      this.sub_id = 0
    },
    // todo: for categories *******************************
    //*******************************
    //*******************************
    checkIsMother(){

      if (this.is_mother){
        router.push('/mother_items')
        return
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/check`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.process===0){
             this.is_CRUD = false

            }


          })
          .catch();

    },

    async fetchOrganizationalPosts() {
      const response = await fetchResource('/organization/post/all', {
        method: 'POST',
      })

      this.organizationPosts = response.all
    },
    async handleUpdateOrganizationPost(item) {
      try {
        await updateResource(`processes/${item.id}/post`, {
          organization_post_id: item.organization_post.id
        })
        toast.success('مالک با موفقیت تعیین شد')
      } catch (error) {
        console.error('Error updating item:', error);
      }
    },
  },
  mounted() {
    this.checkIsMother()
    this.fetchAllProcesses()
    this.fetchItems()
    this.fetchOrganizationalPosts()
  },
  computed: {
    nameCatHeight() {
      return this.nameCat ? `${this.nameCat.length*2}px` : 'auto';
    },
    title_enHeight() {
      return this.title_en ? `${this.title_en.length*2}px` : 'auto';
    },
    filteredItems() {
      return this.allProcesses.filter(item => {
        if (this.searchProcesses) {
          const titleIncludes = item['title'] && item['title'].includes(this.searchProcesses);
          const categoryIncludes = item['category'].includes(this.searchProcesses);
          const code = item['code'].includes(this.searchProcesses);

          return titleIncludes || categoryIncludes || code;
        } else {
          return true; // در صورتی که searchProcesses خالی باشد، همه موارد نمایش داده شوند.
        }
      });
    },


}
}
</script>

<style scoped>
.row {
  padding: .5vw;
}

@media print {
  .no-print, .hide {
    display: none;
  }
}

</style>